export default {
  pageTitle: 'Layanan Re-Shell',
  metaDescription: 'TEF menyediakan layanan re-shell untuk mengganti shell heat exchanger dan vessel yang aus, mengembalikan peralatan ke kondisi operasi penuh.',
  sidebar: {
    heading: 'Daftar Pemeliharaan dan Rekondisi',
    weldingOverlay: 'Welding Overlay',
    patching: 'Patching',
    piping: 'Piping',
    reshell: 'Re-Shell',
    retubing: 'Re-Tubing',
  },
  title: 'Re-shell',
  heading: 'Layanan Penggantian dan Pengelasan Shell Heat Exchanger',
  paragraph1: 'Kami menyediakan layanan pengelasan profesional untuk penggantian shell heat exchanger guna memastikan performa yang andal dan efisien. Baik dikerjakan di workshop kami yang lengkap maupun langsung di lokasi Anda, tim ahli kami menangani seluruh proses dengan presisi dan sesuai standar industri.',
  paragraph2: 'Pendekatan kami yang fleksibel meminimalkan downtime sekaligus memberikan hasil berkualitas tinggi yang disesuaikan dengan kebutuhan spesifik Anda. Percayakan pada kami untuk mengembalikan keutuhan dan fungsi heat exchanger Anda melalui penggantian shell yang presisi dan layanan pengelasan profesional.',
  steps: {
    step1: 'Persiapan Shell',
    step2: 'Annealing Shell',
    step3: 'Pemotongan Shell',
    step4: 'Pelepasan Shell',
    step5: 'Perakitan Shell',
    step6: 'Hydrotest',
    step7: 'NDT Shell',
  },
};
